import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas/root';
import * as reducers from './reducers';

const logger = store => next => action => {
    let result;
    console.groupCollapsed("dispatching", action.type);
    console.log('prev state', store.getState());
    console.log('action', action);
    result = next(action);
    console.log('next state', store.getState());
    console.groupEnd();
    return result;
};

const saver = store => next => action => {
    let result = next(action);
    //localStorage['qtpoker'] = JSON.stringify(store.getState())
    return result
};

const storeFactory = ( initialState={} ) => {

    // applyMiddleware(logger, saver, reduxThunk)(createStore)(
    //     combineReducers(reducers)
    // );

    // NEW Approach with Saga
    //
    const sagaMiddleware = createSagaMiddleware();
    const store = createStore(
        combineReducers(reducers),
        initialState,
        composeWithDevTools(applyMiddleware(sagaMiddleware)),
    );
    // initSagas(sagaMiddleware);
    sagaMiddleware.run(rootSaga);

    return store;
}


export default storeFactory
